import { createFeatureSelector } from '@ngrx/store';
import { CampaignSearchState } from '../models/campaign-search.model';
import {
  WizardConfigurationState,
  WizardSetupState,
  WizardState,
  WizardWhatState,
  WizardWhenState,
  WizardWhoState,
} from '../models/wizard.model';
import { AdhocListLineReducer, AdhocListLineState } from './adhoc-list-line.reducer';
import { campaignExecutionsReducer, CampaignExecutionsState } from './campaign-executions.reducer';
import { CampaignSearchReducer } from './campaign.search.reducer';
import { CreateNewListReducer, CreateNewListState } from './create-new-list.reducer';
import { EstimationTargetSampleReducer, EstimationTargetSampleState } from './estimation-target-sample.reducer';
import { ListsReducer, ListsState } from './lists.reducer';
import { PreviewListReducer, PreviewListState } from './preview-list.reducer';
import { SideNavReducer, SidenavState } from './sidenav.reducer';
import { WizardSetupReducer } from './wizard-setup.reducer';
import { WizardWhatReducer } from './wizard-what.reducer';
import { WizardWhenReducer } from './wizard-when.reducer';
import { WizardWhoReducer } from './wizard-who.reducer';
import { WizardReducer } from './wizard.reducer';
import { WizardConfigurationReducer } from './wizard-configuration.reducer';

export const featureCampaignsName = 'Campaigns';

export interface DragonflyState {
  lists: ListsState;
  sidenav: SidenavState;
  previewList: PreviewListState;
  createNewList: CreateNewListState;
  campaignSearch: CampaignSearchState;
  campaignExecutions: CampaignExecutionsState;
  wizard: WizardState;
  wizardSetup: WizardSetupState;
  wizardWho: WizardWhoState;
  wizardWhat: WizardWhatState;
  wizardWhen: WizardWhenState;
  wizardConfiguration: WizardConfigurationState;
  adhocListLine: AdhocListLineState;
  estimationTargetSample: EstimationTargetSampleState;
}

export const moduleCampaignsReducers = {
  lists: ListsReducer,
  sidenav: SideNavReducer,
  previewList: PreviewListReducer,
  createNewList: CreateNewListReducer,
  campaignSearch: CampaignSearchReducer,
  campaignExecutions: campaignExecutionsReducer,
  wizard: WizardReducer,
  wizardSetup: WizardSetupReducer,
  wizardWho: WizardWhoReducer,
  wizardWhat: WizardWhatReducer,
  wizardWhen: WizardWhenReducer,
  wizardConfiguration: WizardConfigurationReducer,
  adhocListLine: AdhocListLineReducer,
  estimationTargetSample: EstimationTargetSampleReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(featureCampaignsName);
